import { FC, memo } from 'react'
import { TextProps, Text, Tooltip } from '@chakra-ui/react'

import { Highlight } from 'components'

type Props = TextProps & {
  hasHighlight?: boolean
  highlightQuery?: string
  children?: string
  characterLimit?: number
}

const TextWithCharacterLimit: FC<Props> = ({
  hasHighlight = false,
  highlightQuery = '',
  characterLimit = 40,
  children,
  ...textProps
}) => {
  if (!children) {
    return <Text></Text>
  }

  const belowCharacterLimit = children.length <= characterLimit

  const text = belowCharacterLimit ? children : `${children.substring(0, characterLimit)}...`

  if (hasHighlight) {
    return (
      <Tooltip isDisabled={belowCharacterLimit} label={children}>
        <Text {...textProps}>
          <Highlight query={highlightQuery}>{text}</Highlight>
        </Text>
      </Tooltip>
    )
  }

  return (
    <Tooltip isDisabled={belowCharacterLimit} label={children} textAlign="center">
      <Text {...textProps}>{text}</Text>
    </Tooltip>
  )
}

export default memo(TextWithCharacterLimit)
